import React from "react";
import { cn } from "../../lib/cn";

const PAD = { none: "", sm: "p-3", md: "p-3.5", lg: "p-5" };

/**
 * Plain panel: solid surface, hairline border, no shadow.
 * `interactive` adds a border emphasis on hover (no lift).
 * `tone="dark"` forces a constant dark panel (for accent areas on light pages).
 */
export const Card = React.forwardRef(function Card(
  { as: Comp = "div", padding = "md", interactive = false, tone = "default", className, children, ...props },
  ref
) {
  return (
    <Comp
      ref={ref}
      className={cn(
        "glass rounded-md",
        tone === "dark" && "on-dark",
        interactive && "hover:border-line/25",
        PAD[padding],
        className
      )}
      {...props}
    >
      {children}
    </Comp>
  );
});

export function CardHeader({ className, children, ...props }) {
  return (
    <div className={cn("flex items-start justify-between gap-4", className)} {...props}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children, ...props }) {
  return (
    <h3 className={cn("font-display text-base font-semibold tracking-tight text-ink", className)} {...props}>
      {children}
    </h3>
  );
}

export function CardBody({ className, children, ...props }) {
  return <div className={cn("text-sm leading-relaxed text-text", className)} {...props}>{children}</div>;
}

export default Card;
